import { authAction } from '../actionType';


export const userReducer = (state, action) => {
    switch (action.type) {
        case authAction.SAVE_USER:
            return {
                ...state,
                user: action.payload,
            };
        case authAction.REMOVE_USER:
            return {
                user: null,
                userOwnedData: null
            };
        case authAction.SAVE_USER_OWNED_DATA:
            return {
                ...state,
                userOwnedData: {
                    url: action.payload.url,
                    role: action.payload.role
                }
            }
        default:
            return state;
    }
}